import React from 'react';
import { useEffect, useState } from "react";
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { formatDate, generatePDF, getDateCombination, isImageValidPng, onlyAlphabets } from '../../commonClass/CommonValidation'
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import CustomTable from '../../../customControl/CustomTable';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../ImageUpload/ImageCommon';
import CommonFilter from '../../../customControl/CommonFilter';

const Inclusionmaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [disabled, setDisabled] = useState(false);
    const [editdisabled, setEditDisabled] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [formValue, setFormValue] = useState(
        {
            InclusionId: 0,
            InclusionName: '',
            IsActive: false,
            ShortName: '',
            IconName: '',
            IconPath: '',
            IconFile: ''
        }
    );
    const [inclusionlistdata, setInclusionListData] = useState([]);
    const [uploadedImage, setUploadedImage] = useState('');
    const [deleteImage, setDeleteImage] = useState('');
    const [filteritems, setFilterItems] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    //#region Get List data
    const getInclusionDataList = async () => {
        const InclusionListdata = await getAllData("/master/v1/getallinclusion");
        InclusionListdata?.data?.map((obj) => {
            obj.IsActiveFormat = obj?.isActive ? 'Active' : 'InActive';
            obj.CreatedDateFormat = formatDate(obj?.createdDate);
            return obj;
        })
        setInclusionListData(InclusionListdata?.data ? InclusionListdata?.data : []);
        setFilterItems(InclusionListdata?.data ? InclusionListdata?.data : []);
    }

    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            getInclusionDataList().then(() => { dispatch(loaderActions.end()) });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

    }, []);

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });
    }, [user])

    const handleUploadImageLoad = (e) => {
        let error = {}
        setEditDisabled(true);
        setFormErrors({});
        setErrorMessage('');
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files[0];
            const filename = getDateCombination(files.name);
            setFormValue({
                ...formValue,
                IconName: filename,
                IconPath: 'CMS/inclusionMaster/' + filename,
                IconFile: files
            });
        }
        else {
            document.getElementById("select_icon_id").value = "";
            setFormValue({ ...formValue, BannerFileName: '', BannerPath: '' });
            error.IconPath = "Only PNG file type is accepted.";
            setFormErrors(error);
            return;
        }
    }

    const removeImage = () => {
        document.getElementById("select_icon_id").value = "";
        formValue.IconName = ''
        formValue.IconPath = ''
        formValue.IconFile = ''
        setEditDisabled(true);
        setErrorMessage('')
        setFormErrors({});
        setUploadedImage('');
    };

    const columns = [
        {
            name: 'Inclusion Name',
            key: 'inclusionName',
            sortable: true,
            float: "left",
            selector: (inclusion) => inclusion.inclusionName,
        },
        {
            name: 'Short Name',
            key: 'shortName',
            sortable: true,
            float: "left",
            selector: (inclusion) => inclusion.shortName,
        },
        {
            name: 'Active',
            key: 'IsActiveFormat',
            sortable: true,
            float: "left",
            selector: (inclusion) => inclusion.IsActiveFormat
        },
        {
            name: 'Created Date',
            key: 'CreatedDateFormat',
            sortable: true,
            float: "left",
            selector: (inclusion) => new Date(inclusion.createdDate),
            format: (inclusion) => inclusion.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: (inclusion) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditMode(inclusion.inclusionId)}></i></button>
        },
        {
            name: 'View',
            selector: (inclusion) => <button type='button' className='border-0 p-0 bg-body set_disableclr'><i className="fa fa-eye" onClick={() => handleViewMode(inclusion.inclusionId)}></i></button>
        }
    ];

    const handleAddClick = async () => {
        if (validateData()) {
            let filterdata;
            filterdata = inclusionlistdata ?
                buttonaddeditText === "Add" ?
                    inclusionlistdata?.filter(issec => issec.inclusionName.toLowerCase() === formValue.InclusionName.toLowerCase())
                    :
                    inclusionlistdata?.filter(issec => issec.inclusionId !== formValue.InclusionId && issec.inclusionName.toLowerCase() === formValue.InclusionName.toLowerCase())
                : [];
            if (filterdata?.length > 0) {
                setErrorMessage('You can not enter duplicate value.');
                return;
            }
            else {
                dispatch(loaderActions.start());
                let statusoftoken = await verifytoken();
                if (statusoftoken) {
                    const InclusionData = buttonaddeditText === "Add" ? await postUsersData('/master/v1/insertinclusion', formValue) : await patchUsersData("/master/v1/updateInclusion", formValue)

                    if (!InclusionData.status && !InclusionData.data) {
                        dispatch(loaderActions.end());
                        setErrorMessage(InclusionData.message);
                        return;
                    }
                    if (InclusionData.status) {
                        formValue?.IconFile && await ImageUpload('CMS/inclusionMaster/', formValue?.IconName, formValue?.IconFile)
                        formValue?.IconFile && deleteImage && await ImageDelete(deleteImage)
                        formValue?.IconPath?.length <= 0 && deleteImage && await ImageDelete(deleteImage)
                        if (InclusionData.data > 0) {
                            dispatch(loaderActions.end());
                            dispatch({ type: 'ALERTING', message: InclusionData.message })
                            clear();
                        }
                        else {
                            dispatch(loaderActions.end());
                            dispatch({ type: 'ALERTING', message: InclusionData.message })
                            return;
                        }
                    }
                    else {
                        dispatch(loaderActions.end());
                        dispatch({ type: 'ALERTING', message: InclusionData.message })
                        return;
                    }
                }
                else {
                    ClearLocalStorage();
                    dispatch(loaderActions.end());
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                }
            }
        }
    }

    const validateData = () => {
        let errorMessage = {};
        let isValid = true;
        if (typeof formValue.InclusionName === 'string' && formValue.InclusionName?.trim()?.length === 0) {
            errorMessage['InclusionName'] = 'Please enter Inclusion Name'
            document.getElementById('txtinclusion').focus()
            isValid = false;
        }
        if (typeof formValue.InclusionName === 'string' && formValue.InclusionName?.trim()?.length > 500) {
            errorMessage['InclusionName'] = 'Maximum length allowed for inclusion is 500 characters.'
            document.getElementById('txtinclusion').focus()
            isValid = false;
        }

        if (formValue.IconPath.length > 0 && !formValue.ShortName.trim()) {
            errorMessage['ShortName'] = 'Cannot leave blank, input is mandatory.'
            isValid = false;
        }
        if (formValue.ShortName.trim()?.length > 0 && formValue.IconPath.length <= 0) {
            errorMessage['IconPath'] = 'Cannot leave blank, input is mandatory.'
            isValid = false;
        }

        if (formValue?.IconFile) {
            const files = formValue?.IconFile;
            let fileSize = files.size / 1024;
            fileSize = fileSize / 1024
            if (!isImageValidPng(files.name) && files) {
                errorMessage['IconPath'] = 'Only PNG file type is accepted.'
                isValid = false;
            } else if (fileSize > 5) {
                errorMessage['IconPath'] = 'Cannot upload file that exceeds 5 MB.'
                isValid = false;
            }
        }
        setFormErrors(errorMessage);
        return isValid;
    }

    const handleEditMode = (id) => {
        setDisabled(false);
        setEditDisabled(false);
        setButtonAddEditText("Update");
        setSerachDisable(true);
        setErrorMessage('');
        RetriveData(id);
    }

    const handleViewMode = (id) => {
        setDisabled(true);
        setEditDisabled(false);
        setSerachDisable(true);
        setErrorMessage('');
        RetriveData(id);
    }

    function RetriveData(id) {
        setFormErrors({});
        inclusionlistdata?.map(obj => {
            if (obj.inclusionId === id) {
                let tempObj = {
                    InclusionId: obj.inclusionId ? obj.inclusionId : 0,
                    InclusionName: obj.inclusionName ? obj.inclusionName : '',
                    IsActive: obj.isActive ? obj.isActive : false,
                    ShortName: obj.shortName ? obj.shortName : '',
                    IconName: obj.iconName ? obj.iconName : '',
                    IconPath: obj.iconPath ? obj.iconPath : '',
                }
                setUploadedImage(obj?.iconPath ? `${CommonFileURLWithFolder}${obj.iconPath}` : '')
                setDeleteImage(obj?.iconPath ? `${CommonFileURLWithFolder}${obj.iconPath}` : '')
                setFormValue({ ...formValue, ...tempObj })
            }
        });
    }

    //#region image upload
    const onChange = (name, value) => {
        setEditDisabled(true);
        setFormErrors({});
        setErrorMessage('');
        setFormValue({ ...formValue, [name]: value });
    };

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            formValue.IsActive = e
            setFormErrors({});
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            formValue.IsActive = !formValue?.IsActive
            setEditDisabled(true);
            setFormErrors({});
            setErrorMessage('');
        }
        setModalShow(false);
    }
    //#endregion

    //#region handle clear operation
    const clear = () => {
        setFormValue({
            ...formValue, InclusionId: 0, InclusionName: '',
            IsActive: false, ShortName: '', IconName: '', IconPath: '', IconFile: '',
        });
        getInclusionDataList();
        setButtonAddEditText('Add');
        setDisabled(false);
        setEditDisabled(true);
        setFormErrors({});
        setErrorMessage('');
        setSerachDisable(false);
        setSerachBy('All');
        setSearchValue('');
        document.getElementById("select_icon_id").value = "";
        setDeleteImage('');
        setUploadedImage('');
    }
    //#endregion

    //#region handle pdf and excel import
    const PdfExport = () => {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = inclusionlistdata?.map((obj) => keys?.map((key) => obj[key]));
        generatePDF(pdfColumns, rows, "InclusionMaster", "Inclusion Master");
    }
    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, inclusionlistdata, "InclusionMaster", "InclusionMaster.xls");
    }
    //#endregion

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Inclusion Master</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row gy-4">
                                <div className='col-md-12'>
                                    <div className='row'>
                                        {errorMessage && <div className="text-danger pb-3 text-center"> {errorMessage} </div>}
                                        <div className="col-lg-2 col-md-12 col-sm-12 mb-lg-1">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Inclusion Name</label>
                                        </div>
                                        <div className=" col-lg-10 col-md-12 col-sm-12 mb-lg-1">
                                            <textarea type="Rich Text Box" rows={2} id="txtinclusion" className="form-control"
                                                name="InclusionName"
                                                value={formValue.InclusionName}
                                                onChange={(e) => onChange(e.target.name, e.target.value)}
                                                disabled={disabled ? true : false}
                                                placeholder="Inclusion"
                                            >
                                            </textarea>
                                            {formErrors.InclusionName && <p className='text-danger text-start w-100 text-break'> {formErrors.InclusionName} </p>}
                                        </div>

                                        <div className="col-lg-2 col-md-12 col-sm-12 my-2">
                                            <label className={`col-form-label ${formValue?.ShortName?.trim()?.length > 0 ? 'required' : ''} `} htmlFor='select_icon_id'>Select Icon</label>
                                        </div>

                                        <div className=" col-lg-4 col-md-12 col-sm-12 mb-lg-1 my-2">
                                            <div className="input-group">
                                                <input
                                                    name='BannerImage'
                                                    type="file"
                                                    id="select_icon_id"
                                                    className="form-control btn_add"
                                                    accept=".png"
                                                    disabled={disabled ? true : false}
                                                    onChange={handleUploadImageLoad}
                                                />
                                                <label className="input-group-text" htmlFor='select_icon_id'>Browse</label>
                                            </div>
                                            {formValue.IconName && <p className='text-start overflow-hidden mb-0 w-100 text-break' data-bs-toggle="tooltip" data-bs-placement="left" title={formValue.IconName}>{formValue.IconName}</p>}
                                            {formErrors.IconPath && <p className='text-danger text-start w-100 text-break'>{formErrors.IconPath}</p>}
                                        </div>

                                        <div className="col-lg-2 col-md-12 col-sm-12 my-2">
                                            <label htmlFor="inputPassword6" className={`col-form-label ${formValue?.IconFile ? 'required' : ''}`}>Short Name</label>
                                        </div>

                                        <div className=" col-lg-4 col-md-12 col-sm-12 mb-lg-1 my-2">
                                            <input
                                                className='form-control'
                                                disabled={disabled ? true : false}
                                                name='ShortName'
                                                placeholder='Short Name'
                                                value={formValue.ShortName}
                                                onChange={(e) => onChange(e.target.name, onlyAlphabets(e.target.value))}
                                                maxLength={15}
                                            />
                                            {formErrors.ShortName && <p className='text-danger text-start'>{formErrors.ShortName}</p>}
                                        </div>

                                        <div className="col-lg-2 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                                        </div>
                                        <div className="col-9 col-lg-6" disabled={false}>

                                            <Switch
                                                onChange={handleisActive}
                                                checked={formValue?.IsActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />

                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                {formValue?.IconFile &&
                                    (
                                        <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2">
                                            <img loading='lazy'
                                                src={URL.createObjectURL(formValue?.IconFile)} className="img-fluid w-100" alt=''
                                            />
                                            <button onClick={() => removeImage()} type="button" data-close style={{ objectposition: "right top;", position: "absolute", fontSize: "36px", background: 'none', border: 'none' }} disabled={disabled ? true : false} >&times;</button>
                                        </div>
                                    )}
                                {(!formValue?.IconFile && uploadedImage?.trim()?.length > 0) && (
                                    <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2" >
                                        <img loading='lazy'
                                            src={uploadedImage} className="img-fluid w-100" alt=''
                                        />
                                        <button onClick={() => removeImage()} type="button" data-close style={{ objectposition: "right top;", position: "absolute", fontSize: "36px", background: 'none', border: 'none' }} disabled={disabled ? true : false} >&times;</button>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={clear} >Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filteritems}
                        searchDisabled={serchdisable}
                        getdata={getInclusionDataList}
                        setlistdata={setInclusionListData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={filteritems}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default Inclusionmaster